import React, { useCallback } from 'react';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';

import { IconButton } from 'ui-components/components/button/icon-button';
import { Text, TextType } from 'ui-components/components/text';
import { noop } from 'ui-components/default-props/noop';

import DataDrivenLogo from '../data-driven-logo';
import messages from './messages';
import { PackageOrConfirmationText } from './package-or-confirmation-text';
import style from './style.module.less';

/** @typedef {import('../../prop-types/shipping-strategy-carrier-service').ShippingStrategyCarrierService} ShippingStrategyCarrierService */
/** @typedef {import('../../prop-types/rate-shopper-carrier-service').RateShopperCarrierService} RateShopperCarrierService */

/**
 *
 * @param {object} props
 * @param {ShippingStrategyCarrierService|RateShopperCarrierService} props.carrierService
 * @param {(serviceId: string, sellerLabelProviderId: string) => void} props.onCarrierServiceRemoved
 * @param {boolean} props.shouldAllowRemoval
 * @param {boolean} props.shouldShowPackageAndConfirmation
 * @returns {React.JSX.Element}
 */
export const CarrierServiceTag = ({
  carrierService,
  onCarrierServiceRemoved = noop,
  shouldAllowRemoval = false,
  shouldShowPackageAndConfirmation = false,
}) => {
  const onCarrierServiceRemoval = useCallback(() => {
    onCarrierServiceRemoved(carrierService.serviceId, carrierService.sellerLabelProviderId);
  }, [onCarrierServiceRemoved, carrierService]);

  const { carrierId, labelProviderId, name, accountNickname, packageName, confirmationName } = carrierService;
  return (
    <div className={style['carrier-tag']}>
      <DataDrivenLogo
        aria-label={name}
        carrierId={Number.parseInt(carrierId, 10)}
        className={style['carrier-logo']}
        fillProviderId={Number.parseInt(labelProviderId, 10)}
        logoType='icon'
        providerId={Number.parseInt(labelProviderId, 10)}
      />
      <Text textType={TextType.Description} value={name} />
      {accountNickname ? (
        <Text className={style['account-nickname']} textType={TextType.Description} value={`(${accountNickname})`} />
      ) : null}
      {shouldShowPackageAndConfirmation ? (
        <>
          <PackageOrConfirmationText value={packageName} />
          <PackageOrConfirmationText value={confirmationName} />
        </>
      ) : null}
      {shouldAllowRemoval && onCarrierServiceRemoved ? (
        <IconButton
          ariaLabelMessageDescriptor={messages.removeCarrierServiceArialLabelText}
          icon={faTimes}
          onClick={onCarrierServiceRemoval}
        />
      ) : null}
    </div>
  );
};
